module.exports = __webpack_public_path__ + "static/media/rudford-hamon-jelly-places.292c22b4.jpg";